<template>
  <ItemTable
    ref="itemTable"
    :collectionFilters="getCollectionFilters"
    :columns="columns"
    :emptyCollectionMessage="emptyMessage"
    :inDetailsAsidePanel="true"
    :itemType="osMetadata[os].itemType"
    :selectionItemText="selectionItemText"
    :showBound="false"
    :showSeachForm="true"
    :storeModule="osMetadata[os].storeModule"
    :useDropDownFilterComponent="dropdownFilter"
  />
</template>
<script>
import {
  FilterComponentConsts,
  ItemTableConsts,
  ItemTypeConsts,
  ItemTypeLabels,
  ItemTypeRoutes,
  PolicyConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { ospPolicyNames } from 'client/util/Constants/OsPatchMgmtConstants';
import ConfigurationNameCategories from 'client/components/ItemTable/BodyComponents/ConfigurationNameCategories.vue';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';
import ItemTablePropsMixin from 'client/components/ItemTable/mixins/ItemTablePropsMixin';
import Util from 'client/util/Util';
import pluralize from 'pluralize';

const { policyTemplateTypes } = PolicyConsts;
const {
  android,
  ios,
  linux,
  mac,
  windows,
} = policyTemplateTypes;

const { columnTypes } = ItemTableConsts;
const {
  policyTemplateAndroid,
  policyTemplateIos,
  policyTemplateLinux,
  policyTemplateMac,
  policyTemplateWindows,
} = ItemTypeConsts;

export default {
  name: 'PolicyTemplateItemTable',

  components: {
    ItemTable,
  },

  mixins: [ItemTablePropsMixin],

  props: {
    gettingStartedItemType: {
      type: String,
      default: ItemTypeConsts.policies,
    },
    os: {
      type: String,
      required: true,
      validator(value) {
        return Object.values(policyTemplateTypes).includes(value);
      },
    },
  },

  data() {
    return {
      osMetadata: {
        [linux]: {
          itemType: policyTemplateLinux,
          storeModule: StoreModuleMap[policyTemplateLinux],
        },
        [mac]: {
          itemType: policyTemplateMac,
          storeModule: StoreModuleMap[policyTemplateMac],
        },
        [ios]: {
          itemType: policyTemplateIos,
          storeModule: StoreModuleMap[policyTemplateIos],
        },
        [windows]: {
          itemType: policyTemplateWindows,
          storeModule: StoreModuleMap[policyTemplateWindows],
        },
        [android]: {
          itemType: policyTemplateAndroid,
          storeModule: StoreModuleMap[policyTemplateAndroid],
        },
      },
    };
  },

  computed: {
    columns() {
      return [
        {
          classNames: {
            body: [columnTypes.nameColumn, 'policyTemplatePadding'],
            heading: ['policyTemplatePadding'],
          },
          bodyComponent: ConfigurationNameCategories,
          bodyComponentProps: {
            os: this.os,
          },
          headingText: 'Name',
          sortBy: 'displayName',
        },
        {
          bodyComponent: 'PolicyDescription',
          classNames: {
            body: ['policyTemplatePadding'],
            heading: ['policyTemplatePadding'],
          },
          sortBy: 'description',
          headingText: 'Description',
        },
        {
          classNames: {
            body: ['policyTemplateConfigureButton'],
          },
          bodyComponent: 'PolicyTemplateConfigureButton',
          bodyComponentProps: {
            handleClick: this.handleConfigureClick,
            buttonText: 'configure',
          },
        },
      ];
    },

    dropdownFilter() {
      return this.gettingStartedItemType !== ItemTypeConsts.osPatchManagement
        ? FilterComponentConsts.PolicyCategoryDropDownFilter : '';
    },
    emptyMessage() {
      return `No ${this.os} ${pluralize(ItemTypeLabels[this.gettingStartedItemType])} are available.`;
    },

    getCollectionFilters() {
      const filters = [];

      if (this.gettingStartedItemType === ItemTypeConsts.osPatchManagement) {
        filters.push({
          name: 'name',
          operator: 'in',
          value: ospPolicyNames.join('|'),
        });
      } else {
        filters.push(...ospPolicyNames.map(name => ({
          name: 'name',
          operator: 'ne',
          value: name,
        })));
      }

      return filters;
    },
  },

  methods: {
    handleConfigureClick(item) {
      Util.redirect(`${ItemTypeRoutes[this.gettingStartedItemType]}/configure/${this.os}/${item.id}`);
    },
  },
};
</script>
